import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  InputAdornment
} from "@mui/material";
import { numbersOnly } from "../../utilities/strings";
import { SIG_FIGS } from '../../resources/constants';
import {TextFieldRightAligned} from '../../utilities/theme';

const apiInit = {
  ingredient: "",
  quantity: "",
};

const ApiList = (props) => {
  const {
    data = [{...apiInit}],
    onChange,
    errors = {},
    results = [],
    countRange = { min: 0, max: 5 },
    unit='mg',
    numberField={
      label:'Number of APIs'
    },
    capsules
  } = props;

  const [count, setCount] = useState(1);


  useEffect(() => {
    let newList = Array.from({ length: count }, (_) => ({ ...apiInit }));
    newList = [...data, ...newList].slice(0, count);
    onChange(newList);
  }, [count]);

  const onChangeCount = (e) => {
    let value = numbersOnly(e.target.value);
    value = value < countRange.min ? countRange.min : value;
    value = value > countRange.max ? countRange.max : value;
    setCount(value);
  };

  const onChangeItem = (n, v, i) => {
    //console.log(n, v, i);
    let newList = [...data];
    let item = newList[i];
    item[n] = v;
    newList.splice(i, 1, item);
    onChange(newList);
  };

  const renderCount = (
    <Grid container>
      <Grid item xs={4} my={1}>
        <TextField
          required
          name="count"
          label={numberField.label}
          onChange={onChangeCount}
          value={count}
          fullWidth
          {...TextFieldRightAligned}
        />
      </Grid>
    </Grid>
  );

  const labelSize = capsules ? 6 : 9;
  const renderList = (
    <Grid item xs={8}>
      {data.map((item, i) => {
        
        
        const { ingredient, quantity, packStat } = item;

        return (
          <Grid container spacing={1} py={1} key={i}>
            <Grid item xs={labelSize}>
              <TextField
                label={`Name of API #${i + 1}`}
                name="ingredient"
                error={errors[i]?.ingredient}
                helperText={errors[i]?.ingredient}
                value={ingredient}
                fullWidth
                onChange={(e) => onChangeItem("ingredient", e.target.value, i)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Quantity"
                required
                value={quantity}
                onChange={(e) =>
                  onChangeItem("quantity", numbersOnly(e.target.value, true), i)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography>{unit}</Typography>
                    </InputAdornment>
                  ),
                }}
                error={errors[i]?.quantity}
                helperText={errors[i]?.quantity}
                {...TextFieldRightAligned}
              />
            </Grid>
            {capsules &&
              <Grid item xs={3}>
                <TextField
                  label="Pack Stat"
                  required
                  value={packStat}
                  onChange={(e) =>
                    onChangeItem("packStat", numbersOnly(e.target.value, true), i)
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography>{unit}</Typography>
                      </InputAdornment>
                    ),
                  }}
                  error={errors[i]?.packStat}
                  helperText={errors[i]?.packStat}
                  {...TextFieldRightAligned}
                />
              </Grid>}
          </Grid>
        );
      })}
    </Grid>
  );

  const resultSize = capsules ? 6:12;
  const renderResults = (
    <Grid item xs={4}>
      {results.map((item, i) => {
        const { quantity, packStat } = i < data.length ? data[i] : {};
        return (
          <Grid container p={1}>
            <Grid item xs={resultSize}>
              <TextField
                label="Quantity Required"
                value={item.toFixed(SIG_FIGS)}
                readOnly
                fullWidth={!capsules}
                InputProps={{
                  variant: "secondary",
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography>g</Typography>
                    </InputAdornment>
                  ),
                }}
                {...TextFieldRightAligned}
              />
            </Grid>
            {capsules &&
              <Grid item xs={resultSize}>
                <TextField
                  label="Percent Filled"
                  value={(quantity / packStat * 100).toFixed(SIG_FIGS)}
                  readOnly
                  InputProps={{
                    variant: "secondary",
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography>%</Typography>
                      </InputAdornment>
                    ),
                  }}
                  {...TextFieldRightAligned}
                />
              </Grid>
            }
          </Grid>
        );
      })}
    </Grid>
  );

  return (
    <Grid container>
      {renderCount}
      {renderList}
      {renderResults}
    </Grid>
  );
};

export default ApiList;
